import React from "react"
import PropTypes from "prop-types"
import { InlineWidget, useCalendlyEventListener } from "react-calendly"
import useTracking from "hooks/useTracking"
import { getEventInformation } from "utils/calendly"
import { identifyUser } from "utils/identifyUser"

const RequestMeeting = ({ segmentTrackingId, meetingScheduleUrl }) => {
  const { track } = useTracking()

  useCalendlyEventListener({
    onEventScheduled: async (e) => {
      const eventId = e.data.payload.event.uri.split("/").pop()
      const inviteeId = e.data.payload.invitee.uri.split("/").pop()
      const eventInfo = await getEventInformation({ eventId, inviteeId })

      if (!eventInfo) {
        console.error("Error fetching event information")
        return
      }

      await identifyUser({ user: eventInfo.invitee })

      track("Meeting Scheduled", {
        name: eventInfo.event.name,
        startTime: eventInfo.event.startTime,
        host: eventInfo.event.user,
        guest: eventInfo.invitee.email,
        elementId: segmentTrackingId,
      })
    },
  })

  return (
    <InlineWidget
      url={meetingScheduleUrl}
      pageSettings={{
        backgroundColor: "ffffff",
        hideEventTypeDetails: false,
        hideLandingPageDetails: false,
        primaryColor: "#E03015",
        textColor: "#4d5055",
      }}
      styles={{
        height: "400rem",
        width: "100%",
      }}
    />
  )
}

export default RequestMeeting

RequestMeeting.propTypes = {
  segmentTrackingId: PropTypes.string.isRequired,
  meetingScheduleUrl: PropTypes.string.isRequired,
}
